/* eslint-disable prettier/prettier */

(function (exports) {
  exports.price = function (
    customer_tags,
    product_tags,
    sku,
    price,
    qty,
    store_url
  ) {
    var is_kmt_emea = false;
    if (store_url === 'kmt-emea') {
      is_kmt_emea = true;
    }

    var emea_agreements = {};
    var trade_agreements = {};
    var agreements = {};

    var default_agreement = '';
    var default_line_discount = 1;

    var emea_discounts = {
      sku: null,
      group: null,
      global: null,
    };

    // 1.0 - If a customer is already logged in, look through the customer tags for any tag which contains "#.ta". This tag will be used to extract trade agreement info.
    if (customer_tags && customer_tags.length > 0) {
      for (var x = 0; x < customer_tags.length; x++) {
        var customer_tag = customer_tags[x].toLowerCase();
        var tag_split = customer_tag.split(':');
        if (customer_tag.indexOf('erpcustomer') !== -1 && is_kmt_emea) {
          emea_agreements[tag_split[1]] = 1; // Value not used but needs to be truthy to indicate that the customer has this TA
        } else if (customer_tag.indexOf('#.gd') !== -1) {
          emea_agreements[tag_split[1]] = parseFloat(tag_split[2]);
          if (customer_tag.indexOf('#.gd:global') !== -1) {
            emea_discounts.global = parseFloat(tag_split[2]);
          }
        } else if (customer_tag.indexOf('#.ta') !== -1) {
          trade_agreements[tag_split[1]] = parseFloat(tag_split[2]);
        }
      }
    }

    if (Object.keys(emea_agreements).length > 0) {
      agreements = emea_agreements;
    } else if (Object.keys(trade_agreements).length > 0) {
      agreements = trade_agreements;

      default_agreement = Object.keys(agreements)[0];
      default_line_discount = agreements[default_agreement];
    }

    var trade_agreement = default_agreement;
    var line_discount = default_line_discount;

    // save original total without discounts
    var original_total = price;
    var discounted_total = original_total;

    // Lowercase sku for equality checks
    sku = sku.toLowerCase();

    // ERP pricing
    var erp_price = 0;
    var erp_sku;

    // Promo pricing
    var promo_price = 0;
    var promo_sku;

    // Variable for checking CTA
    var no_cta = false;

    // Controls the line discount from customer tag
    var apply_discount = true;

    // Variable which controls the "ALL_CUSTOMER" discount
    var skip_ac = false;

    // Variables for minimum pricing
    var min_set = false;
    var min_price = price;
    var min_sku = '';

    // 2.0 - Check product tags
    for (var x in product_tags) {
      var tag = product_tags[x].toString().toLowerCase();

      // 2.1.1 - Check for ERP price tag ex: #.erpprice:A-11073:400
      if (tag.indexOf('#.erpprice') !== -1) {
        if (sku === tag.split(':')[1]) {
          erp_price = parseInt(tag.split(':')[2]) * qty;
          erp_sku = tag.split(':')[1];
        }

        // 2.1.2 - Check for promo ex: #.promo:A-11073:200
      } else if (tag.indexOf('#.promo') !== -1) {
        if (sku === tag.split(':')[1]) {
          promo_price = parseInt(tag.split(':')[2]) * qty;
          promo_sku = tag.split(':')[1];
        }

        // 2.1.3 - Check product tags for a minimum price tag, product price cannot be lower than the set min price ex: #.min:A-11073:0|350
      } else if (tag.indexOf('#.min') !== -1) {
        min_sku = tag.split(':')[1];

        // set mininum price if product SKU matches tag SKU
        if (sku == min_sku) {
          min_set = true;
          var min_tag = tag.split(':')[2];
          min_price = parseInt(min_tag.split('|')[1]);
        }
      }

      // 2.2 - Check for matching product TA
      if (Object.keys(agreements).length > 0) {
        // If a product has a "#..no_discount" tag, then we can safely skip over it. This tag will ALWAYS be the exact first tag due to special formatting
        if (product_tags[0] == '#..no_discount') {
          discounted_total = original_total;
          return [original_total, discounted_total];
        }

        var data = tag.split(':');

        if (tag.indexOf('#.ta') !== -1) {
          // Check for matching TA name and sku
          if (agreements[data[3]] && sku == data[2]) {
            // Because we found a TA for the customer, we want to skip over the ALL_CUSTOMERS discount
            skip_ac = true;
            var ignore_ld = data[1];
            var bulk_discount = [];

            // trade_agreement = data[3];
            if (!is_kmt_emea) {
              line_discount = parseFloat(agreements[data[3]]);
            }

            // separate bulk discount into an array
            for (var i = 4; i < data.length; i++) {
              bulk_discount.push(data[i]);
            }

            // We know that price will always start at the fourth entry but since there may be multiple prices (volume discount), we need to loop through all of them.
            // The PIM should sort the prices by quantity so going in reverse allows us to break out earlier if we hit the correct quantity threshold.
            for (var x in bulk_discount.reverse()) {
              if (typeof bulk_discount[x] == 'string') {
                var q_p = bulk_discount[x].split('|');

                // When we surpass the qty threshold, apply the discount and break out of the loop
                if (qty >= parseInt(q_p[0])) {
                  if (is_kmt_emea) {
                    emea_discounts.sku = parseFloat(q_p[1]);
                    break;
                  } else {
                    discounted_total = parseInt(q_p[1]) * qty;

                    // We apply the line discount last so set the TA line_discount rule so we can use it later
                    if (ignore_ld == 'true') {
                      apply_discount = false;
                    } else {
                      apply_discount = true;
                    }
                    break;
                  }
                }
              }
            }
          }
        } else if (tag.indexOf('#.gd') !== -1) {
          // Check for matching TA name and sku
          if (agreements[data[3]] && sku == data[2]) {
            // Because we found a TA for the customer, we want to skip over the ALL_CUSTOMERS discount
            skip_ac = true;

            emea_discounts.group = parseFloat(agreements[data[3]]);
          }
        }
      }
    }

    if (is_kmt_emea && emea_discounts.global) {
      skip_ac = true;
    }

    // 3.0 - If we were unable to find a TA for customer or if we were unable to find this customer's TA on a particular product, apply THE ALL_CUSTOMERS discount.
    if (!skip_ac) {
      // 3.1 - This loops acts the same as the one above for customer TAs, only now we are looking for just the ALLCUSTOMER tag
      for (var x in product_tags) {
        var tag = product_tags[x].toString().toLowerCase();

        if (typeof tag == 'string' && tag.indexOf('#.ta') !== -1) {
          var data = tag.split(':');

          if (data[3] == 'allcustomers' && sku == data[2]) {
            var ignore_ld = data[1];
            var bulk_discount = [];

            for (var i = 4; i < data.length; i++) {
              bulk_discount.push(data[i]);
            }

            for (var x in bulk_discount.reverse()) {
              if (typeof bulk_discount[x] == 'string') {
                var q_p = bulk_discount[x].split('|');

                if (qty >= parseInt(q_p[0])) {
                  discounted_total = parseInt(q_p[1]) * qty;

                  if (ignore_ld == 'true') {
                    apply_discount = false;
                  } else {
                    apply_discount = true;
                  }
                  break;
                }
              }
            }
            break;
          }
        } else {
          // 3.2 - No CTA logic for ERP and promo
          if (erp_sku == sku) {
            no_cta = true;

            // set original price to ERP if ERP > $0
            if (erp_price != 0) {
              original_total = erp_price;
            }

            if (promo_price == 0) {
              if (erp_price != 0) {
                // set price to ERP
                discounted_total = erp_price;
              } else {
                discounted_total = original_total;
              }
              // promo > $0
            } else if (promo_price > 0 && promo_sku == sku) {
              // set price to lowest of promo price vs personal discount price
              discounted_total = Math.min(
                erp_price - promo_price,
                erp_price * line_discount
              );
              apply_discount = false;
            }
          }
        }
      }
    }

    // 4.0 - Apply customer's global discount if applicable
    if (Object.keys(emea_agreements).length > 0) {
      if (emea_discounts.sku) {
        discounted_total = discounted_total * emea_discounts.sku;
      } else if (emea_discounts.group) {
        discounted_total = discounted_total * emea_discounts.group;
      } else if (emea_discounts.global) {
        discounted_total = discounted_total * emea_discounts.global;
      }
    } else if (apply_discount) {
      discounted_total = discounted_total * line_discount;
    }

    // 5.0 - Apply additional ERP and promo logic if there is a CTA
    if (!no_cta && erp_sku == sku) {
      // 5.1 - CTA == shopify price
      if (discounted_total == original_total) {
        // promo price > $0
        if (promo_price > 0 && promo_sku == sku) {
          discounted_total = original_total - promo_price;
          // promo price == $0
        } else if (promo_price == 0) {
          discounted_total = original_total;
        }
        // 5.2 - CTA < shopify
      } else if (discounted_total < original_total) {
        // promo price > $0
        if (promo_price > 0 && promo_sku == sku) {
          // CTA >= ERP
          if (discounted_total >= erp_price) {
            // set price to whichever is lower between (shopify - promo) and CTA price
            discounted_total = Math.min(
              original_total - promo_price,
              discounted_total
            );
            // CTA price < ERP
          } else if (discounted_total < erp_price) {
            original_total = erp_price;
            // set price to whichever is lower between (ERP - promo) and CTA price
            discounted_total = Math.min(
              erp_price - promo_price,
              discounted_total
            );
          }
          // promo price is $0
        } else if (promo_price == 0) {
          // CTA price < ERP
          if (discounted_total < erp_price) {
            original_total = erp_price;
            // set price to whichever is lower between ERP and CTA price
            discounted_total = Math.min(erp_price, discounted_total);
            // Don't change the total if CTA >= ERP
          } else if (discounted_total >= erp_price) {
            // original price should still be the shopify price and sale price is CTA
          }
        }
      }
    }

    // 6.0 - If the product has a min price tag, we want to make sure that the current total does not go below the set min price
    if (min_set) {
      var min_total_price = min_price * qty;
      // 6.1 - change price to minumum
      if (min_total_price >= discounted_total) {
        // change price to minumum
        discounted_total = min_total_price;
      }
    }

    // 7.0 - Return new prices
    return [original_total, discounted_total];
  };
})(typeof exports === 'undefined' ? (this['pdp_script'] = {}) : exports);
